var exports = {
  "H": "RelationshipsViewAllButton_LeadingSpacer__BOmxLG",
  "L": "RelationshipsViewAllButton_Label__bYp73R",
};

module.exports = exports;
